import React from 'react'
import bgImg from '../../assets/img/praksa_logo.png'
import './Home.css'

const themeColor = '#6193f1'

const Home = () => {
  return (
    <div className="overlay-page">
      <div className="home-content">
        <img src={bgImg} alt="logo" width={180} className="home-logo" />
        <h3 className="h2">ระบบบริหารจัดการ SmartCity ทต.แพรกษา</h3>
        <p className="home-subtitle">
          ยินดีต้อนรับเข้าสู่ระบบ <b style={{ color: themeColor, fontSize: '18px' }}>SmartCity ทต.แพรกษา</b>
        </p>
      </div>
    </div>
  )
}

export default Home
